import React from "react";
import { makeStyles } from "@material-ui/core";

import { i18n } from "../../translate/i18n";
import ViewOnceImg from "../../assets/miscPng/viewOnce.png";

const useStyles = makeStyles((theme) => ({
  viewOnceMainContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "5px",
  },

  viewOnceMainContainerDeleted: {
    opacity: 0.7,
    filter: "grayscale(80%)",
  },

  viewOnceContentContainer: {
    width: "100.00%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: "5px",
    borderRadius: "5px",
    padding: "3px",
  },

  viewOnceLogo: {
    width: "50px",
    height: "50px",
    borderRadius: "50.00%",
  },

  viewOnceContentMessageContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    gap: "3px",
  },

  viewOnceOpenedSpan: {
    color: "#998",
  },

  learnMoreContainer: {
    width: "100.00%",
    textAlign: "right",
  },

  learnMore: {
    cursor: "pointer",
    color: theme.palette.secondary.ackCheck,
    textDecoration: "none",
    "&:hover": { textDecoration: "underline", },
  },
}));

const ViewOnceMessageWeb = ({ message }) => {
  //  ***************
  //  ** Variables **
  //  ***************
  const classes = useStyles();
  const mainContainerClassName = message.isDeleted ? `${classes.viewOnceMainContainer} ${classes.viewOnceMainContainerDeleted}` : `${classes.viewOnceMainContainer}`;
  const learnMoreURL = "https://faq.whatsapp.com/1077018839582332?cms_id=1077018839582332&draft=false";


  //  ***************
  //  ** Functions **
  //  ***************
  const handleLearnMoreClick = () => {
    window.open(learnMoreURL);
  };



  //  ************
  //  ** Return **
  //  ************
  return (
    <div className={mainContainerClassName}>
      <div className={classes.viewOnceContentContainer}>
        <img alt="View Once Logo" src={ViewOnceImg} className={classes.viewOnceLogo} />

        <div className={classes.viewOnceContentMessageContainer}>
          <span>
            {i18n
              .t("messageBodyWrapper.viewOnce")
              .replace(
                "<action>"
                , message.fromMe ? i18n.t("messageBodyWrapper.messageActions.sent") : i18n.t("messageBodyWrapper.messageActions.received")
              )}
          </span>

          {message.ack === 5 && (
            <div className={classes.viewOnceContentMessageContainer}>
              <span className={classes.viewOnceOpenedSpan}>{i18n.t("messageBodyWrapper.viewOnceOpened")}</span>
            </div>
          )}

          <div className={classes.learnMoreContainer}>
            <span className={classes.learnMore} onClick={handleLearnMoreClick}>{i18n.t("messageBodyWrapper.learnMore")}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewOnceMessageWeb;
